import React from "react";
import { mainPageAnchors } from "../common/utilities";
import Hidden from "@material-ui/core/Hidden";
import LinkScroll from "./header/LinkScroll";
import { useTranslation } from "react-i18next";

import styles from "./LocalNavMain.module.scss";

const itemHeight = 26;
const itemMarginTop = 4;

function LocalNavMainItem({ data }) {
  const { t } = useTranslation();

  //old val: -125
  const linkScrollOffset = -132; //height of header (only used in desktop)

  return (
    <li>
      <LinkScroll className={styles.nav_link} to={data.id}> {/*  offset={linkScrollOffset} */}
        <span className={styles.label}>{t(data.name)}</span>
        <span className={styles.icon}>
          <i className={`icon-${data.icon}`} />
        </span>
      </LinkScroll>
    </li>
  );
}

export default function LocalNavMain({ creator }) {
  const anchors = Object.values(mainPageAnchors).filter(element => {
    return element.name == mainPageAnchors.CONTENT_CREATOR.name
      ? creator
      : true;
  });

  return (
    <Hidden smDown>
      <div className={styles.local_nav_container}>
        <div className={styles.local_nav_subcontainer}>
          <ul className={styles.local_nav}>
            {anchors.map(item => (
              <LocalNavMainItem data={item} key={item.id} />
            ))}
          </ul>
        </div>
      </div>
    </Hidden>
  );
}
